import Vue from "vue"

export default Vue.extend({
  data: () => ({
    pages: 1,
    error: "",
  }),

  computed: {
    page: {
      get (): number {
        const page = Number(this.$route.query.page)

        if (!Number.isSafeInteger(page))
          return 1

        return (page > 0) ? page : 1
      },

      set (page: number) {
        this.$router.push({
          query: {
            ...this.$route.query,
            page: String(page),
          },
        })
      },
    },
  },

  methods: {
    scrollToTop () {
      window.scrollTo(0, 0)
    },
  },
})
